import {
  Dialog,
  DialogContent,
  DialogTitle,
  LinearProgress,
} from '@mui/material';
import { connect } from 'redux-bundler-react';
import { withStyles } from 'tss-react/mui';
import React from 'react';

const styles = theme => ({
  dialog: {
    zIndex: 4000,
  },
});

const DcvMetricsLoadingDialog = ({
  classes,
  workstation,
  session,
  open,
  onClose,
  status,
}) => {
  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      aria-labelledby="confirmation-dialog-title"
      open={open}
      className={classes.dialog}
    >
      <DialogTitle className={classes.dialogTitle}>{status}</DialogTitle>

      <DialogContent className={classes.content}>
        <LinearProgress />
      </DialogContent>
    </Dialog>
  );
};

export default connect(
  'selectRecipeQueryParameter',
  'selectActiveImagePipeline',
  withStyles(DcvMetricsLoadingDialog, styles),
);
